// returns boolean stating if comparedSiteName and original siteName are the same
export const isCurrentSite = (comparedSiteName, siteName) => {
    return comparedSiteName.toLowerCase() === siteName.toLowerCase();
};
export const isFieldValid = (field, key = undefined) => {
    if (key)
        return !!(field && field.value && field.value[key]);
    return !!(field && field.value);
};
export const isValidType = (field, type = undefined) => {
    if (type)
        return field && field.value && typeof field.value === type;
    return false;
};
export const isCookieSettingsLinkValid = (field) => {
    return !!(field && field.value && field.value.text && field.value.class);
};
